import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
interface AuthContextProps {
  isAuthenticated: boolean | null;
  orgNumber: string | null;
  uid: string | null;
  mosqueName: string | null;
  mosqueLogo: string | null;
  setOrgNumber: (orgNumber: string) => void;
  setUid: (uid: string) => void;
  setMosqueName: (mosqueName: string) => void;
  setMosqueLogo: (mosqueLogo: string) => void;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [orgNumber, setOrgNumber] = useState<string | null>(null);
  const [uid, setUid] = useState<string | null>(null);
  const [mosqueName, setMosqueName] = useState<string | null>(null);
  const [mosqueLogo, setMosqueLogo] = useState<string | null>(null);

  const navigate = useNavigate();
  const location = useLocation();

  const publicRoutes = ["/innlogging"];

  const isPublicRoute = publicRoutes.includes(location.pathname);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token && !isPublicRoute) {
      console.log("No token found, redirecting to login");
      setIsAuthenticated(false);
      navigate("/innlogging");
    } else {
      setIsAuthenticated(true);
      const storedOrgNumber = sessionStorage.getItem("orgNumber");
      const storedUid = sessionStorage.getItem("uid");
      const storedMosqueName = sessionStorage.getItem("mosqueName");
      const storedMosqueLogo = sessionStorage.getItem("mosqueLogo");

      if (storedOrgNumber) setOrgNumber(storedOrgNumber);
      if (storedUid) setUid(storedUid);
      if (storedMosqueName) setMosqueName(storedMosqueName);
      if (storedMosqueLogo) setMosqueLogo(storedMosqueLogo);
    }
  }, [isPublicRoute]);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        orgNumber,
        uid,
        mosqueName,
        mosqueLogo,
        setOrgNumber,
        setUid,
        setMosqueName,
        setMosqueLogo,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within an AuthProvider");
  return context;
};

export default AuthProvider;
